import { memo, useMemo } from 'react';

import { CircularProgress, Typography } from '@mui/material';

import NotAdminMessage from '@components/NotAdminMessage';
import LogoutFooter from '@components/LogoutFooter';

import { useInterviewOptions } from '@providers/InterviewsProvider';
import InterviewSelectionButtons from '@components/InterviewSelectionButtons';
import LoadingPaper from '@components/LoadingPaper';
import { Navigate } from 'react-router-dom';

function InterviewSelector() {
    const { allInterviews, loading, selectedInterview } = useInterviewOptions();

    const renderInterviewButtons = useMemo(() => {
        if (allInterviews) {
            return <InterviewSelectionButtons />;
        } else {
            return <CircularProgress sx={{ alignSelf: 'center' }} />;
        }
    }, [allInterviews]);

    // Redirect to survey if an interview is selected
    if (allInterviews?.length && selectedInterview) {
        return <Navigate to="/app/survey" replace={true} />;
    }

    return (
        <LoadingPaper loading={loading}>
            {!allInterviews?.length ? (
                <NotAdminMessage />
            ) : (
                <div
                    style={{
                        paddingTop: '4vh',
                        textAlign: 'center',
                        minHeight: '85vh',
                        display: 'flex',
                        width: '100%', // Changed from 100vw to respect parent container
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ width: '100%', maxWidth: 500, padding: '0 1rem' }}>
                        <Typography
                            variant="h5"
                            className="blue-text"
                            sx={{ textAlign: 'center', marginTop: '1rem', marginBottom: '2rem' }}
                        >
                            Select which survey you'd like to manage
                        </Typography>
                        {renderInterviewButtons}
                    </div>
                    {/* Only show footer when sidebar is hidden (no interview selected) */}
                    {!selectedInterview && <LogoutFooter />}
                </div>
            )}
        </LoadingPaper>
    );
}

export default memo(InterviewSelector);
